
import { useOnScrollTransition } from "@/hooks";
import { ContactDto } from "@/types";
import { defineComponent, PropType, ref } from "vue";
import ContactItem from "./ContactItem.vue";

export default defineComponent({
  name: "ContactList",
  components: { ContactItem },
  props: {
    entities: {
      type: Array as PropType<ContactDto[]>,
    },
  },
  setup() {
    const list = ref([]);

    useOnScrollTransition(list, "animate-scroll-left");

    return { list };
  },
});
